<template>
    <v-container fluid class="admin-page">
        <!-- Header -->
        <div class="page-header">
            <div>
                <p class="page-kicker">Back-office</p>
                <h1 class="page-title">Demandes Alumni</h1>
            </div>

            <v-sheet class="page-actions" color="transparent">
                <v-text-field v-model="pattern" v-on:keyup.enter="() => { fetch = true }" prepend-inner-icon="mdi-magnify"
                    label="Recherche" placeholder="Nom, référence, carte..." density="compact" variant="outlined" hide-details class="search-field" />
                <v-btn theme="dark" color="#2563eb" @click="() => { fetch = true }" class="action-button">
                    <v-icon>mdi-cloud-sync-outline</v-icon> Recharger
                </v-btn>
                <!-- <div class="mx-1"></div>
                <v-btn theme="dark" color="green darken-2" @click="showCreateDemandePage">
                    <v-icon>mdi-plus-circle-outline</v-icon> Nouvelle demande
                </v-btn> -->
            </v-sheet>
        </div>

        <demande-indiv-index :pattern="pattern" :isLoading="isLoading" @handleLoading="(val) => {isLoading = val}" :fetch="fetch" @disableFetch="() => {fetch = false}"></demande-indiv-index>
        <v-overlay :model-value="isLoading" class="align-center justify-center" :z-index="204">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>
<script lang="js">
import EmptyData from '../../../components/shared/EmptyData.vue';
import DemandeIndivIndex from '../../../components/Demande/DemandeIndivIndex.vue';
import profiles from '../../../functions/profiles';

export default {
    name: 'DemandeAlumniIndex',

    components: { EmptyData, DemandeIndivIndex },
    data() {
        return {
            pattern: '',
            demandes: [],
            isLoading: false,
            pagination: {
                page: 1,
                total_page: 1
            },
            tab: null,
            fetch: false
        };
    },

    computed: {
        canAccess() {
            return [profiles.PROFILE_CSA, profiles.PROFILE_SUPERADMIN].includes(this.$store.getters['auth/user'].role);
        }
    },

    created() {
        this.fetchDemandes();
        this.$emit('currentPage', 'Demandes');
    },

    methods: {
        fetchDemandes() {
            this.isLoading = true;
            if (this.pattern.length) this.pagination.page = 1;
            axios
                .get(`/demandes`, { params: { pattern: this.pattern, page: this.pagination.page } })
                .then((resp) => {
                    if (resp) {
                        this.demandes = this.canAccess ? resp.data : [];
                    }
                })
                .catch((e) => {
                    this.$swal.fire({ title: 'Erreur', text: e.message, icon: 'error' });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        showDemande(item) {
            this.$router.push({
                name: 'DemandeShow',
                params: { id: item.id }
            });
        },
        showCreateDemandePage() {
            this.$router.push({
                name: 'DemandeCreate'
            });
        }
    }
};
</script>
<style scoped>
.admin-page {
    max-width: 100%;
}
.page-header {
    align-items: center;
    display: flex;
    gap: 24px;
    justify-content: space-between;
    margin-bottom: 12px;
}
.page-kicker {
    color: #64748b;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin: 0 0 4px;
    text-transform: uppercase;
}
.page-title {
    color: #0f172a;
    font-size: 1.3rem;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 1.2;
    margin: 0;
}
.page-actions {
    align-items: center;
    display: flex;
    gap: 12px;
    min-width: min(620px, 100%);
}
.search-field {
    flex: 1 1 320px;
}
.action-button {
    border-radius: 8px;
    box-shadow: none;
    height: 36px;
    text-transform: none;
}
@media (max-width: 900px) {
    .page-header {
        align-items: stretch;
        flex-direction: column;
    }
    .page-actions {
        min-width: 0;
        width: 100%;
    }
}
</style>
